import { FilterBar, FilterType } from '@/components/common/FilterBar';
import { FormWrapper } from '@/components/venue/components';
import { Controller, useForm } from 'react-hook-form';
import Input from '@/components/form/input';
import MultiSelectItem from '@/components/form/multiselect';
import { FilterFormData } from '@/types';
import { SelectChangeEvent } from '@mui/material';
import { ChangeEvent, useEffect } from 'react';
import { transformSelectOptions } from '@/utils/helper';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import useCategoryHook from '@/hooks/useCategoryHook';

type FilterProps = {
  onAdd: () => void;
  // onExport: () => void;
  onCategoryChange: (e: SelectChangeEvent<any>) => void;
  onKeywordChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const Filter = ({
  onAdd,
  // onExport,
  onKeywordChange,
  onCategoryChange,
}: FilterProps) => {
  const { t } = useTranslation();

  const location = useLocation();
  let params = queryString.parse(window.location.search);
  const { control, reset } = useForm<FilterFormData>({
    defaultValues: {
      keyword: '',
      asset: [],
    },
  });

  useEffect(() => {
    reset({
      keyword: Array.isArray(params?.keyword)
        ? params?.keyword[0] ?? ''
        : params?.keyword ?? undefined,
      asset: Array.isArray(params?.category)
        ? params?.category ?? []
        : [params?.category ?? ''],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const { categories } = useCategoryHook();

  return (
    <FilterBar
      type={FilterType.GENERIC}
      onAdd={onAdd}
      // onExport={onExport}
      hasButton
      buttonText={t('Add new location')}
    >
      <FormWrapper>
        <Controller
          control={control}
          name="asset"
          render={({ field }) => {
            const { value, onChange } = field;
            return (
              <MultiSelectItem
                options={transformSelectOptions(categories)}
                value={value ?? []}
                onChange={e => {
                  onChange(e);
                  onCategoryChange(e);
                }}
                placeholder={t('Category')}
              />
            );
          }}
        />

        <Controller
          control={control}
          name="keyword"
          render={({ field }) => {
            const { value, onChange } = field;
            return (
              <Input
                inputType={1}
                onChange={e => {
                  onChange(e);
                  onKeywordChange(e);
                }}
                placeholder={t('Search')}
                value={value}
              />
            );
          }}
        />
      </FormWrapper>
    </FilterBar>
  );
};
